/**
 * PWA - Lógica de instalação (beforeinstallprompt)
 * Armazena o evento para disparo manual. Não força popup automático.
 * UI do prompt pode ser feita no componente InstallPWA ou em qualquer lugar que importar showInstallPrompt.
 */

let deferredPrompt = null;

/**
 * Inicializa o listener de beforeinstallprompt. Deve ser chamado uma vez no carregamento da app.
 * Captura e armazena o evento para uso posterior (disparo manual).
 */
export function initInstallPrompt() {
  if (typeof window === 'undefined') return;

  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    deferredPrompt = e;
    try {
      window.dispatchEvent(new CustomEvent('pwa-install-available'));
    } catch (_) {}
  });

  // Opcional: limpar referência após instalação (navegador pode disparar 'appinstalled')
  window.addEventListener('appinstalled', () => {
    deferredPrompt = null;
  });
}

/**
 * Retorna o evento de instalação armazenado (ou null se não disponível).
 * @returns {BeforeInstallPromptEvent | null}
 */
export function getInstallPromptEvent() {
  return deferredPrompt ?? null;
}

/**
 * Verifica se o prompt de instalação está disponível (evento foi capturado).
 * @returns {boolean}
 */
export function isInstallPromptAvailable() {
  return deferredPrompt != null;
}

/**
 * Exibe o prompt nativo de instalação (Android/Chrome).
 * Só tem efeito se o evento foi capturado; em iOS não há beforeinstallprompt.
 * @returns {Promise<{ outcome: 'accepted' | 'dismissed' } | null>} userChoice ou null se indisponível
 */
export function showInstallPrompt() {
  if (!deferredPrompt) {
    return Promise.resolve(null);
  }
  deferredPrompt.prompt();
  return deferredPrompt.userChoice.then((result) => {
    const outcome = result?.outcome ?? 'dismissed';
    if (outcome === 'accepted') {
      deferredPrompt = null;
    }
    return { outcome };
  });
}
